import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() isVisible = true;
  @Output() pageChange = new EventEmitter<number>();

  leftArrowSrc =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/6414af45e1f395fd2c76333d4e1f696de0e4aa40?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  rightArrowSrc =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/ea3ac1fa25ebee79157a8c66798a4058580ecf8b?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';

  get activeClasses(): string {
    return 'flex justify-center items-center self-stretch px-2 my-auto w-10 h-10 text-base font-bold text-white whitespace-nowrap bg-blue-500 min-h-10 rounded-[40px]';
  }

  get inactiveClasses(): string {
    return 'flex justify-center items-center self-stretch p-2 my-auto text-base font-medium text-black whitespace-nowrap min-h-10';
  }

  get visiblePages(): (number | string)[] {
    const pages: (number | string)[] = [];

    // Always show first page
    pages.push(1);

    // Logic for showing pages around current page
    if (this.currentPage > 3) {
      pages.push('...');
    }

    // Pages around current page
    const start = Math.max(2, this.currentPage - 1);
    const end = Math.min(this.totalPages - 1, this.currentPage + 1);

    for (let i = start; i <= end; i++) {
      if (i !== 1 && i !== this.totalPages) {
        pages.push(i);
      }
    }

    // Add ellipsis if needed
    if (this.currentPage < this.totalPages - 2) {
      pages.push('...');
    }

    // Always show last page if more than 1 page
    if (this.totalPages > 1) {
      pages.push(this.totalPages);
    }

    return pages;
  }

  // Handle click on a page number (which could be number or string)
  handlePageClick(page: number | string): void {
    if (typeof page === 'number') {
      this.onPageChange(page);
    }
  }

  onPageChange(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }
}
